<mbs-button
  class="d-block"
  [customClasses]="'w-100 lh-base'"
  [disabled]="disabled"
  [isCtrl]="true"
  (click)="openSelectionModal()">
  @if (selectedNames) {
    <mbs-text-ellipsis
      tooltipClass="tooltip-lg"
      [tooltip]="selectedNames">
      {{ selectedNames }}
    </mbs-text-ellipsis>
  } @else {
    {{ 'shared:placeholders.companies' | i18next }}
    <span class="fa fa-pencil"></span>
  }
</mbs-button>
